import React, { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";

/**
 * "1ère mission = 0 % de frais Renforteo" — top banner on /devis.
 * Dismissible, persists dismissal in sessionStorage.
 */
export default function FirstMissionBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissed = sessionStorage.getItem("renforteo_first_mission_banner_dismissed");
        if (!dismissed) setVisible(true);
    }, []);

    if (!visible) return null;

    return (
        <div
            className="bg-gradient-to-r from-[#F5A623] to-[#F5A623]/90 text-[#0B192C] shadow-md"
            data-testid="first-mission-banner"
        >
            <div className="max-w-6xl mx-auto px-5 md:px-8 py-3 flex items-center gap-3 flex-wrap">
                <Gift size={20} className="shrink-0" />
                <div className="flex-1 text-sm font-semibold leading-snug">
                    <span className="font-display font-black uppercase tracking-wide">Offre lancement</span>
                    {" "}—{" "}Votre 1<sup>ère</sup> mission Renforteo à Lyon = <b>0 % de frais plateforme</b> (économie moyenne 12-20 % sur la facture totale, vs 15 % standard).
                </div>
                <button
                    onClick={() => {
                        sessionStorage.setItem("renforteo_first_mission_banner_dismissed", "1");
                        setVisible(false);
                    }}
                    className="shrink-0 opacity-70 hover:opacity-100 transition"
                    aria-label="Fermer"
                    data-testid="first-mission-banner-close"
                >
                    <X size={18} />
                </button>
            </div>
        </div>
    );
}
